import React from 'react';
import ReduxProvider from '../../../providers/ReduxProvider';
import Tile from '..';

const WithReduxProvider = ({ id, md5, md5Query, md5Page, position, analyticClickFrom, format = 'square', withSelectLot, urlTarget }) => (
  <ReduxProvider>
    <Tile id={id} md5={md5} md5Page={md5Page} md5Query={md5Query} position={position} analyticClickFrom={analyticClickFrom} format={format} withSelectLot={withSelectLot} urlTarget={urlTarget} />
  </ReduxProvider>
);

export default WithReduxProvider;
